import { all, call, spawn } from 'redux-saga/effects';
import watchers from './watchers';

function* rootSaga() {
    const sagas = watchers;

    yield all(
        sagas.map((saga) =>
            spawn(function* () {
                while (true) {
                    try {
                        yield call(saga.watcher, saga.url);
                        break;
                    } catch (e) {
                        console.log(e);
                    }
                }
            })
        )
    );
}

export default rootSaga;
